import { DateTime } from "luxon";
import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";
import { VehicleDataRow } from "./subcomponents";
import { vehicleType } from "../../../services/types.service";
import { FleetContext } from "../../../context";
import { validateSemVar } from "../../../services/text-formatter.service";
import { withSpinner } from "../../../HOC";
import DiagnosticModalContext from "../Modals/DiagnosticModal/DiagnosticModalContext";

export const VehicleSoftwareDetails = ({ vehicle }) => {
  const DEFAULT_FIRMWARE_VERSION = "–.–.–";
  const { t } = useTranslation();
  const { latestDiagnostics } = useContext(DiagnosticModalContext);
  const { findComponentFirmwareVersion } = useContext(FleetContext);

  const systemControllerFirmwareVersion = findComponentFirmwareVersion(vehicle, "systemcontroller");
  const motorDriveFirmwareVersion = findComponentFirmwareVersion(vehicle, "motorcontroller");
  const BMSFirmwareVersion = findComponentFirmwareVersion(vehicle, "battery");

  const radioCertExpiration = vehicle?.radio_cert_expiration
    ? DateTime.fromISO(vehicle.radio_cert_expiration).toLocaleString(DateTime.DATETIME_MED)
    : "";

  const latestDiagnostic = latestDiagnostics && latestDiagnostics[0];

  return (
    <Grid>
      <VehicleDataRow dataKey={t("Vehicles.Detail.LastIngest")}>
        {latestDiagnostic &&
          DateTime.fromISO(latestDiagnostic.ingested).toLocaleString(DateTime.DATETIME_MED)}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.OperationalSpeedLimit")}>
        {latestDiagnostic && `${latestDiagnostic.operational_speed_limit} km/h`}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.SystemControllerFirmware")}>
        {VehicleSoftwareDetails.validateVersion(
          systemControllerFirmwareVersion,
          DEFAULT_FIRMWARE_VERSION,
        )}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.MotorDriveFirmware")}>
        {VehicleSoftwareDetails.validateVersion(
          motorDriveFirmwareVersion,
          DEFAULT_FIRMWARE_VERSION,
        )}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.BMSFirmware")}>
        {VehicleSoftwareDetails.validateVersion(BMSFirmwareVersion, DEFAULT_FIRMWARE_VERSION)}
      </VehicleDataRow>
      {!isEmpty(vehicle.components) && vehicle.components[0].lg69t_gnss_version && (
        <VehicleDataRow dataKey={t("Vehicles.Detail.LG69TGNSSFirmware")}>
          {vehicle?.components[0]?.lg69t_gnss_version || ""}
        </VehicleDataRow>
      )}
      <VehicleDataRow dataKey={t("Vehicles.Detail.GeofenceRulesId")}>
        {vehicle?.geofence_rules_id || ""}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.GeofenceMapId")}>
        {vehicle?.geofence_map_id || ""}
      </VehicleDataRow>
      <VehicleDataRow dataKey={t("Vehicles.Detail.RadioCertExpiration")}>
        {radioCertExpiration}
      </VehicleDataRow>
    </Grid>
  );
};

VehicleSoftwareDetails.propTypes = {
  vehicle: vehicleType.isRequired,
};

VehicleSoftwareDetails.validateVersion = (version, defaultVersion) =>
  validateSemVar(version) ? version : defaultVersion;

export default withSpinner(VehicleSoftwareDetails);
